<template>
    <v-tooltip v-if="!forDialog" bottom>
        <template v-slot:activator="{ on }">
            <v-btn @click="submitQuery" color="primary" v-on="on" :loading="loading" v-if="!iconShaped" e2e-table-query-submit class="mt-2">
                <v-icon v-if="mode === queryModeOptions.FULL_WITH_SAVE_MODE" left small>send_and_archive</v-icon>
                <v-icon v-else left small>send</v-icon>

                {{ buttonName }}
            </v-btn>
            <v-btn @click="submitQuery" class="mr-1" v-else icon :loading="loading" v-on="on" color="secondary" e2e-table-query-submit>
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </template>
        <span>{{ tooltipHint }}</span>
    </v-tooltip>
    <v-btn v-else color="primary" @click="submitQuery" e2e-table-query-submit>
        <div class="d-flex align-center">
            <v-icon v-if="mode === queryModeOptions.FULL_WITH_SAVE_MODE" left small>send_and_archive</v-icon>
            <v-icon v-else left small>send</v-icon>
            {{ buttonName }}
        </div>
    </v-btn>
</template>
<script>
import { queryData } from '@/mixins/query'

export default {
    name: 'QuerySubmit',
    mixins: [queryData],
    props: {
        mode: String,
        query: String,
        tooltipHint: String,
        iconShaped: Boolean,
        consoleSql: String,
        forDialog: Boolean,
        buttonName: String
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        submitQuery: function () {
            if (this.forDialog) {
                this.$emit('closeDialog', { value: true })
            }
            this.loading = true
            const sql = this.query ? this.query : this.consoleSql
            if (sql) {
                const postBody = {
                    command: sql.trim(),
                    mode: this.mode,
                    snid: this.$route.params.snid
                }
                this.$axios
                    .post('/queries', postBody)
                    .then(response => {
                        this.$store.dispatch('showSnackBar', {
                            snackBarText: 'Query has been submitted',
                            snackBarTimeout: 10000,
                            snackBarIcon: 'info'
                        })
                        this.$store.dispatch('snapshotStore/fetchQueries', this.$route.params.snid).finally(() => {
                            this.$emit('success', { value: true })
                        })
                    })
                    .catch(() => {
                        this.$store.dispatch('snapshotStore/fetchQueries', this.$route.params.snid)
                        this.$store.dispatch('showSnackBar', {
                            snackBarText: 'Failed to submit the query, please retry later..',
                            snackBarTimeout: 10000,
                            snackBarIcon: 'error'
                        })
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    }
}
</script>
